import { createSelector } from "reselect";

import { defaultInitialHierarchicalLayoutOptions } from "../../../generic/graph/algos/hierarchical/hierarchicalLayout";
import type { RootState } from "../RootState";

import type { ConfigState } from "./ConfigState";

export const getConfig = (state: RootState): ConfigState => state.config;

export const selectServerVersion = createSelector(getConfig, (config) => config.serverVersion);

export const selectWebUiConfig = createSelector(getConfig, (config) => config.webUIConfig);

const selectStqlConfig = createSelector(getConfig, (config) => config.stqlConfig);

export const selectFeatureFlags = createSelector(selectWebUiConfig, (webUiConfig) => webUiConfig.featureFlags);

export const selectPlayground = createSelector(selectFeatureFlags, (featureFlags) => featureFlags.playground);

export const selectDefaultQueryVersion = createSelector(getConfig, (config) => config.queryVersion);

export const selectSearchResultLimit = createSelector(
	selectWebUiConfig,
	(webUiConfig) => webUiConfig.searchResultLimit,
);

export const selectIsAuthEnabled = createSelector(getConfig, (config) => config.isGuiAuth);

export const selectMaxRenderableVisualElements = createSelector(
	selectWebUiConfig,
	(webUiConfig) => webUiConfig.maxRenderableVisualElements,
);

export const isTrackingPendo = createSelector(selectFeatureFlags, (flags) => flags.trackingPendo);
export const isPlayground = createSelector(selectFeatureFlags, (flags) => flags.playground);

/* ******* */

export const selectDefaultAjaxRequestTimeout = createSelector(
	selectWebUiConfig,
	(webUiConfig) => webUiConfig.defaultAjaxRequestTimeout,
);

export const isTrackingHubSpot = createSelector(selectFeatureFlags, (flags) => flags.trackingHubSpot);

export const selectStqlMaxLevels = createSelector(selectStqlConfig, (stqlConfig) => stqlConfig.maxLevels);

export const selectHierarchicalLayoutOptions = createSelector(selectWebUiConfig, (webUIConfig) => {
	const visualizerSettings = webUIConfig.visualizer;
	return {
		...defaultInitialHierarchicalLayoutOptions(),
		reduceCrossingsSweeps: visualizerSettings.reduceCrossingsSweeps,
		foreignWeightMultiplier: visualizerSettings.foreignWeightMultiplier,
		vertexWidth: visualizerSettings.vertexWidth,
		betweenDummyNodeWidth: visualizerSettings.betweenDummyNodeWidth,
		compactionMaxPlaceBlockDepth: visualizerSettings.compactionMaxPlaceBlockDepth,
		compactionMaxLinkedListIterations: visualizerSettings.compactionMaxLinkedListIterations,
	};
});

export const selectDocLinkUrlPrefix = createSelector(selectWebUiConfig, (config) => config.docLinkUrlPrefix);

export const showWelcomePage = createSelector(selectFeatureFlags, (flags) => flags.showWelcomePage);

export const isOnlineTrial = createSelector(selectFeatureFlags, (flags) => flags.onlineTrial);

export const isTrackingGoogleAnalytics = createSelector(selectFeatureFlags, (flags) => flags.trackingGoogleAnalytics);
